const dataConstants = {
  integrationIds: {
    facebook: "FACEBOOK",
    shopify: "SHOPIFY",
    amazon: "AMAZON",
    googleAds: "GOOGLE_ADS"
  },
};

export default dataConstants;